import { useContext, ChangeEvent } from "react";
import { FormContext, IFormValues } from "../../../contexts/FormContext";
import { TextFieldWrapper, InputField, Label } from "./form-styles";

export interface ITextField {
  field: keyof IFormValues;
  fieldLabel: string;
  type?: string;
  disabled?: boolean;
  isEditable?: boolean;
  readonly?: boolean;
  labelExtraInfo?: JSX.Element;
}

const TextField = ({
  field,
  fieldLabel,
  type,
  disabled,
  readonly,
  labelExtraInfo,
}: ITextField) => {
  const { getFieldValue, updateForm } = useContext(FormContext);
  const fieldValue = getFieldValue(field);
  return (
    <TextFieldWrapper>
      <InputField
        disabled={disabled}
        readOnly={readonly}
        type={type}
        name={field}
        id={field}
        value={fieldValue}
        onChange={(event: ChangeEvent<HTMLInputElement>) =>
          updateForm({ formChange: { field, newValue: event.target.value } })
        }
      />
      <Label htmlFor={field} error={false} hasValue={!!fieldValue}>
        {fieldLabel}
        {labelExtraInfo}
      </Label>
    </TextFieldWrapper>
  );
};

export default TextField;
